
import { login, getUserInfo } from '@/api/login'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'
import store from '@/store'
const user = {
  state: {
    keys: 'user',
    token: getToken(),
    userId: '',
    username: '',
    name: '',
    roles: [],
    userInfo: {}
  },
  mutations: {
    // setUserName: (state, username) => {
    //   state.username = username
    // },
    setToken: (state, token) => {
      state.token = token
    },
    setInfo: (state, data) => {
      if (data) {
        state.userInfo = {...data}
        state.userId = data.userId
        state.roles = data.roles
      }
    }
  },
  actions: {
    login({ commit }, { username, password }) {
      const name = username.trim()
      return new Promise((resolve, reject) => {
        login(name, password).then(({ data }) => {
          const result = data.data
          commit('setToken', result.accessToken)
          setToken(result.accessToken)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        if (!store.getters.token) {
          return
        }
        getUserInfo().then(({ data }) => {
          if (data === undefined) {
            return false
          }
          if (!data) {
            // reject('error')
          }
          commit('setInfo', data.data)
          resolve(data)
        }).catch(() => {
          reject(false)
        })
      })
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('setToken', '')
        // commit('logout')
        removeToken()
        resolve()
      })
    },
    fedLogout() {
      return new Promise(resolve => {
        // commit('setToken', '')
        removeToken()
        resolve()
      })
    }
  }
}
export default user
